import { ICaseDictionary } from '../../idscan/configuration/CaseDictionary';

/**
 * @internal
 */
export class CaseDictionaryService {

	// The service will generate arrays from given dictionary as ins and outs for controlling purposes
	public pascals: string[] = [];
	public camels: string[] = [];
	public types: string[] = [];

	private _dictionary: Record<string, ICaseDictionary>;

	constructor(dictionary: Record<string, ICaseDictionary>) {
		this._dictionary = dictionary;

		Object.keys(dictionary).map((key: string) => {
			this.types.push(dictionary[key].type);
			this.pascals.push(dictionary[key].server);
			this.camels.push(dictionary[key].client);
		});
	}

	/**
	 * Given the element and type of conversion, this function renames the keys of objects that are found in the arrays.
	 * @param element
	 * @param type
	 */
	public convert(element: Record<string, any> = {}, type: 'beautify' | 'uglify'): Record<string, any> {
		const destination: 'server' | 'client' = type === 'beautify' ? 'client' : 'server';

		if (typeof element !== 'object') {
			return element;
		}

		return Object.keys(element).reduce((out, key) => {
			const dict: ICaseDictionary = this._dictionary[Object.keys(this._dictionary).find((e) => {
				return this._dictionary[e][destination === 'client' ? 'server' : 'client'] === key;
			})!];

			const newKey = (dict && (dict.type === type || dict.type === 'both')) ? dict[destination] : key;

			return {
				...out,
				[newKey]: element[key] instanceof Array ? (element[key] as any[]).map((e) => this.convert(e, type)) : element[key]
			};
		}, {});
	}
}
